export default {
  currency: '₹',
  researcherMonth: '708',
  totalResearcherMonth: '1416',
  researcherYear: '447',
  totalResearcherYear: '894',
  totalYear: '5366',
  promotion: 'inr_discount',
  locale: 'in',
};
